export default __webpack_public_path__ + "static/media/icon-new.0a479b22.svg";